import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  private cache = new Map<string, { data: any, expiration: number }>();

  setCache(key: string, data: any, ttl: number): void {
    const expiration = Date.now() + ttl * 1000;
    this.cache.set(key, { data, expiration });
  }

  getFromCache(key: string): any | null {
    const cached = this.cache.get(key);
    if (cached && cached.expiration > Date.now()) {
      return cached.data;
    }
    this.cache.delete(key);
    return null;
  }

  clearCache(key: string): void {
    this.cache.delete(key);
  }

  isExpired(key: string): boolean {
    const cachedItem = this.cache.get(key);
    if (cachedItem) {
      return Date.now() > cachedItem.expiration;
    }
    return true; // Retorna verdadeiro se o item não estiver no cache
  }

  startCacheCleanup(interval = 60000): void {
    setInterval(() => {
      const now = Date.now();
      this.cache.forEach((value, key) => {
        if (value.expiration <= now) {
          this.cache.delete(key);
          console.log(`Cache expirado removido: ${key}`);
        }
      });
    }, interval);
  }

  clearAll(): void {
    this.cache.clear();
  }
}